<template>
  <div class="newsCenter">
    <Header bgColor="rgba(34, 64, 116, 0.9)"></Header>
    <ImgBox :info="infoBoxInfo"></ImgBox>
    <router-view />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import ImgBox from "@/components/ImgBox.vue";
export default {
  name: "NewsCenter",
  components: {
    Header,
    ImgBox,
  },
  data() {
    return {
      // 顶部图片
      infoBoxInfo: {
        img: require("../assets/xwzx.png"),
        name: "新闻中心",
        eng: "NEWS CENTER",
      },
    };
  },
  methods: {
  },
};
</script>

<style scoped lang="less">
@import "../css/productCenter.less";
</style>
